<script setup>
import { ref } from 'vue'
import {__, notify} from "../../../assets/javascripts/library";
import Modal from "../../../assets/components/Modal.vue";
import IbanInput from "../../../assets/components/IbanInput.vue";

const props = defineProps({
  eventId: Number,
  invoiceType: String,
  amount: [String, Number],
  otherText: String,
  receipt: File,
  user_name: String,
  user_email: String,
  user_account_owner: String,
  user_iban: String,
  dynamicText: Object,
  people_in_car: Number,
  material_transportation: Boolean,
  user_id: Number,
})

const finalStep = ref(true)
const user_name = ref(props.user_name)
const user_email = ref(props.user_email)
const user_iban = ref(props.user_iban)
const user_account_owner = ref(props.user_account_owner)
const sending = ref(false)
const success = ref(false)
const decision = ref('')
const errorMsg = ref('')
const confirmaiton = ref(null)


async function sendData() {
  if (!user_name.value) return

  sending.value = true
  errorMsg.value = ''
  success.value = false

  const formData = new FormData()
  formData.append('userId', props.user_id)
  formData.append('name', user_name.value)
  formData.append('email', user_email.value)
  formData.append('eventId', props.eventId)
  formData.append('invoiceType', props.invoiceType)
  formData.append('amount', props.amount)
  formData.append('otherText', props.otherText)
  formData.append('decision', decision.value)
  formData.append('account_owner', user_account_owner.value)
  formData.append('account_iban', user_iban.value)
  formData.append('people_in_car', props.people_in_car)
  formData.append('material_transportation', props.material_transportation)
  if (props.receipt) formData.append('receipt', props.receipt)

  try {
    const response = await fetch('/wp-json/mareike/invoice/create-new', {
      method: 'POST',
      body: formData
    })

    const result = await response.json()

    if (response.ok) {
      success.value = true
      finalStep.value = false
      document.getElementById('main-container').innerHTML = result.message_long
      notify(result.message, 'success')
    } else {


    }
  } catch (err) {
    document.getElementById('main-container').innerHTML = 'Fehler'
    notify(err.message, 'error')

    finalStep.value = false
    errorMsg.value = err.message || 'Unknown error'
  } finally {
    sending.value = false
  }
}
</script>

<template>
  <div v-if="errorMsg" style="color:red">{{ errorMsg }}</div>
  <div v-if="success" style="color:green">Invoice successfully sent!</div>

  <Modal :show="finalStep" :title="__('Please enter your data', 'mareike')" @close="finalStep = false">
    <label>
      <strong>{{__( 'Your name', 'mareike' )}} ({{__( 'No nickname', 'mareike' ) }}):</strong>
    </label><br />
    <input
        type="text"
        onkeyup="mareike_check_contact_name();"
        class="mareike-text"
        id="contact_name"
        name="contact_name" v-model="user_name"
        style="font-size: 14pt; width: 550px;" /><br />

    <label>
      <strong>{{__( 'E-mail address', 'mareike' ) }} ({{__( 'For clarification', 'mareike' ) }}):</strong>
    </label><br />
    <input
        type="email"
        class="mareike-text"
        name="contact_email"
        v-model="user_email"
        style="font-size: 14pt; width: 550px;" /><br />


    <span id="decision" v-if="user_name !== '' && decision === ''">
	  <label><br /><br />
		  <strong>{{__( 'Do you want to donate the amount?', 'mareike') }}</strong>
	  </label><br />

      <button class="mareike-button" style="border-radius: 0; width: 100px;" @click="decision='donation'">{{__( 'Yes', 'mareike')}}</button>
      <button class="mareike-button" style="border-radius: 0; width: 100px;" @click="decision='payout'">{{__( 'No', 'mareike') }}</button>
</span>



    <span id="confirm_donation" v-if="decision === 'donation'">
	    <input type="radio" name="confirmation_radio" value="donation" id="confirmation_radio_donation" v-model="confirmaiton">
	    <label for="confirmation_radio_donation">{{props.dynamicText.CONFIRMATION_DONATE}}</label><br /><br />
      <button class="mareike-button" v-if="confirmaiton !== null && !sending" @click="sendData">{{__( 'Submit invoice', 'mareike')}}</button>
    </span>

    <span id="confirm_payment" v-if="decision === 'payout'">
	    <label>
        <strong>{{__( 'Account owner', 'mareike' ) }}:</strong></label><br />
		    <input type="text" class="mareike-text" name="account_owner" id="account_owner" v-model="user_account_owner" style="font-size: 14pt; width: 550px;" /><br />

	    <label>
        <strong>{{__( 'IBAN', 'mareike' )}}:</strong>
      </label><br />
		<IbanInput class="mareike-text" id="account_iban" name="account_iban" v-model="user_iban" style="font-size: 14pt; width: 550px;" /><br />

	<span v-if="user_account_owner !== '' && user_iban !== ''"><br />
		<input type="radio" name="confirmation_radio" value="payment" id="confirmation_radio_payment"  v-model="confirmaiton">
			<label for="confirmation_radio_payment"> {{ props.dynamicText.CONFIRMATION_PAYMENT }}</label><br /><br />
      <button class="mareike-button" v-if="confirmaiton !== null && !sending" @click="sendData">{{__( 'Submit invoice', 'mareike')}}</button>
	</span>
</span>





    <div v-if="sending">{{ __('Sending...', 'mareike') }}</div>
  </Modal>
</template>

<style scoped>
/* optional styling */
</style>
